import { FilterOptionSchema } from "../components/Filter/filter.data";

export interface WorkFlowStage {
  title: string;
  description: string;
  team: FilterOptionSchema;
  sla: number;
  id: number;
  subtasks: { id: number; name: string }[];
  new: boolean;
  stage_id?: number;
  status?: {
    name: string;
    value: string;
  };
  team_name?: string;
  team_count?: number;
  sla_days?: number;
  active_days?: number;
  integrations?: {
    name: string;
    avatar: string;
  }[];
  due_date?: string;
}
export interface WorkFlowListItem {
  id: number;
  name: string;
  created_at: string;
  owner_name: string;
}

export const INIT_WORKFLOW_STAGE: WorkFlowStage = {
  title: "",
  description: "",
  team: { id: -1, name: "" },
  sla: 0,
  id: -1,
  subtasks: [],
  new: true,
};
